// extracted by mini-css-extract-plugin
module.exports = {"message-text":"message-text__WwYco","message-text--system":"message-text--system__BIf15"};